require('./collapsingToggle.scss');

const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class CollapsingToggle extends React.Component {
    render() {
        const { isExpanded, iconStyle, onClick, customCollapsinToggle } = this.props;
        const iconClassName = classNames('collapsing-toggle__toggle icons', {
            'icons--icon-arrow-up-2': isExpanded,
            'icons--icon-arrow-down-2': !isExpanded,
            [iconStyle]: !!iconStyle,
        });
        const toggleWrapperClass = classNames('collapsing-toggle', {
            [customCollapsinToggle]: customCollapsinToggle,
        });

        return (
            <div className={toggleWrapperClass}>
                <i className={iconClassName} onClick={onClick} />
            </div>
        );
    }
}

CollapsingToggle.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    iconStyle: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    customCollapsinToggle: PropTypes.string,
};

CollapsingToggle.defaultProps = {
    isExpanded: false,
    iconStyle: '',
};

module.exports = CollapsingToggle;
